module.exports = __webpack_public_path__ + "img/req.b1295355.svg";